import React from 'react';
import { useTranslation } from 'react-i18next';
import { mergeTailwindClasses } from '@kontentino/ui';
import { oboOutcomeMessageKey } from 'app/modules/socialLogin/utils/oboOutcome';
import type { RefusedProfile } from 'types/Page';

// More than this and the rest is summed up as "and N more".
export const MAX_LISTED_REFUSED_PAGES = 5;

type Props = {
  refusedProfiles: RefusedProfile[];
  className?: string;
};

// The selected pages a Safe Connect confirm could not connect, each with why.
// Shown in the success view and on onboarding's result step.
const RefusedPagesList = ({ refusedProfiles, className }: Props) => {
  const { t } = useTranslation();
  const listed = refusedProfiles.slice(0, MAX_LISTED_REFUSED_PAGES);
  const moreCount = refusedProfiles.length - listed.length;

  return (
    <div
      className={mergeTailwindClasses(
        'tw-flex tw-flex-col tw-gap-1 tw-text-md tw-text-grayscale-180',
        className,
      )}
      data-cy="obo-confirm_refused-pages"
    >
      <span className="tw-font-semibold">
        {t('newSocialMediaProfile.oboTokenType.refusedTitle')}
      </span>
      <ul className="tw-m-0 tw-flex tw-list-none tw-flex-col tw-gap-1 tw-p-0">
        {listed.map((profile) => (
          <li key={`${profile.type}:${profile.externalId}`}>
            {`${profile.name} — ${t(oboOutcomeMessageKey(profile.outcome))}`}
          </li>
        ))}
      </ul>
      {moreCount > 0 && (
        <span>
          {t('newSocialMediaProfile.oboTokenType.refusedMore', {
            count: moreCount,
          })}
        </span>
      )}
    </div>
  );
};

export default RefusedPagesList;
